export default "__VITE_ASSET__6_NEx6zH__"